import React from "react";
import {
  Typography,
  Box,
  Button,
  Card,
  Grid,
  CardContent,
  CardMedia,
} from "@mui/material";
import { RouteComponentProps } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { BlockStandard } from "components/admin/BlockStandard";
import { PageStandard } from "components/admin/PageStandard";

const useStyles = makeStyles()((theme) => ({
  greenBorder: {
    borderRadius: "12px",
    border: `1px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(2),
    flexWrap: "nowrap",
    minHeight: 0,
    minWidth: 0,
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(2),
  },
  blurContainer: {
    position: "relative",
  },
  blurOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(8),
  },
  card: {
    maxWidth: 360,
    margin: "0 auto",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  centeredContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  mascot: {
    width: 150,
    height: 150,
    marginBottom: theme.spacing(1),
  },
  messageText: {
    maxWidth: 300,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  productCardMedia: {
    height: 140,
    backgroundSize: "contain",
    backgroundPosition: "center",
  },
}));

const PRODUCT_DATA = {
  title: "Controle Remoto Inteligente Un. Infra",
  price: "R$ 149,00",
  imageUrl:
    "https://www.enermatch.com/wp-content/uploads/2024/11/infra-vermelho-01.jpg",
};

export const NoAutomationPage = ({ history }: RouteComponentProps) => {
  const { classes } = useStyles();

  const handleStoreClick = () => {
    history.push("/frames/store", {
      customUrl:
        "https://www.enermatch.com/checkouts/controle-universal-infravermelho/",
    });
  };

  return (
    <PageStandard title="Automação">
      <BlockStandard title="Informação do ambiente">
        <Box className={classes.blurContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box className={classes.greenBorder}>
                <Typography variant="subtitle1" color="primary">
                  Ambientes
                </Typography>
                <Typography variant="h5">-</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className={classes.greenBorder}>
                <Typography variant="subtitle1" color="primary">
                  Dispositivos
                </Typography>
                <Typography variant="h5">-</Typography>
              </Box>
            </Grid>
          </Grid>
          <Box className={classes.blurOverlay} />
        </Box>
      </BlockStandard>
      <Box className={classes.blurOverlay} />
      <BlockStandard title="Eventos automatizados">
        <Box
          className={classes.blurContainer}
          sx={{ minHeight: "350px", minWidth: "100%" }}
        >
          <Box className={classes.blurOverlay}>
            <Box className={classes.centeredContent}>
              <img
                src="/static/img/solutions/no-credentials.png"
                alt="Mascote Enermatch"
                className={classes.mascot}
              />

              <Typography variant="h4" fontWeight="bold">
                OPS!
              </Typography>

              <Typography variant="body1" className={classes.messageText}>
                Para automatizar seu ar-condicionado é só adquirir
                infravermelhos em nossa loja virtual.
              </Typography>

              <Card className={classes.card}>
                <CardMedia
                  component="img"
                  height="200"
                  width="600"
                  image={PRODUCT_DATA.imageUrl}
                  alt={PRODUCT_DATA.title}
                />
                <CardContent>
                  <Typography gutterBottom variant="body1">
                    {PRODUCT_DATA.title}
                  </Typography>
                  <Typography variant="body2" color="primary">
                    {PRODUCT_DATA.price}
                  </Typography>
                </CardContent>
              </Card>

              <Button
                variant="contained"
                color="primary"
                onClick={handleStoreClick}
                sx={{ mt: 2, mb: 2, minWidth: 400 }}
              >
                Ir para a Loja Virtual
              </Button>
            </Box>
          </Box>
        </Box>
      </BlockStandard>
    </PageStandard>
  );
};
